import frappe from './frappe';

const STATUS_MAP = {
  Draft: 'Draft',
  'To Deliver and Bill': 'En proceso',
  'To Bill': 'Por entregar',
  Completed: 'Completada',
  Cancelled: 'Cancelada',
};

function mapOrderStatus(docstatus, status) {
  if (docstatus === 0) return 'Draft';
  return STATUS_MAP[status] || status;
}

export const getOrderRef = async (orderId) => {
  // En Frappe el name IS la referencia
  return orderId;
};

export const getOutstandingOrders = async (customerId) => {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Order?filters=[["customer","=","${customerId}"]]&fields=["name","status","docstatus"]&limit=200`
    );
    // Devuelve un mapa {id: name}
    return Object.fromEntries(data.data.map(o => [o.name, o.name]));
  } catch (error) {
    console.error('Error al obtener órdenes:', error);
    return {};
  }
};

export const getOrderProducts = async (orderId) => {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Order%20Item?filters=[["parent","=","${orderId}"]]&fields=["name","item_code","item_name","qty","rate","amount"]&limit=200`
    );
    return data.data.map(item => ({
      label: item.item_name,
      total_ttc: item.amount,
      qty: item.qty,
      line: item.name,   // ID de la línea (string en Frappe)
      id: item.item_code,
    }));
  } catch (error) {
    console.error(`Error al obtener productos de la orden ${orderId}:`, error);
    return [];
  }
};

export const getOrders = async (customerId) => {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Order?filters=[["customer","=","${customerId}"]]&fields=["name","status","docstatus","transaction_date","grand_total","set_warehouse"]&limit=200`
    );

    const draftOrders = [];
    const activeOrders = [];

    for (const o of data.data) {
      const tag = mapOrderStatus(o.docstatus, o.status);
      const entry = {
        orderId: o.name,
        orderName: o.name,
        date: o.transaction_date,
        total: o.grand_total,
        tag,
        warehouse: o.set_warehouse,
      };
      if (tag === 'Draft') {
        draftOrders.push(entry);
      } else {
        activeOrders.push(entry);
      }
    }

    return { orders: activeOrders, draftOrders };
  } catch (error) {
    console.error('Error al obtener órdenes y productos:', error);
    return { orders: [], draftOrders: [] };
  }
};
